module.exports = __webpack_public_path__ + "static/media/05-kor.7c10ad48.png";